import { defineMessages } from "@formatjs/intl"
import type { VehicleOrigin } from "./VehicleOrigin"

export const vehicleOriginMessages = defineMessages<VehicleOrigin>({
	COMMISSION_CAR: {
		defaultMessage: "Commission car",
		id: "vehicle.vehicleOrigin.commissionCar",
	},
	FACTORY_ORDER: {
		defaultMessage: "Factory order",
		id: "vehicle.vehicleOrigin.factoryOrder",
	},
	LEASE_RETURN: {
		defaultMessage: "Lease return",
		id: "vehicle.vehicleOrigin.leaseReturn",
	},
	PURCHASE_FROM_COMMERCIAL_OWNER: {
		defaultMessage: "Purchase from commercial owner",
		id: "vehicle.vehicleOrigin.purchaseFromCommercialOwner",
	},
	PURCHASE_FROM_IMPORTER: {
		defaultMessage: "Purchase from importer",
		id: "vehicle.vehicleOrigin.purchaseFromImporter",
	},
	PURCHASE_FROM_OTHER_PORSCHE_CENTER: {
		defaultMessage: "Purchase from other Porsche Center",
		id: "vehicle.vehicleOrigin.purchaseFromOtherPorscheCenter",
	},
	PURCHASE_FROM_PRIVATE_OWNER: {
		defaultMessage: "Purchase from private owner",
		id: "vehicle.vehicleOrigin.purchaseFromPrivateOwner",
	},
	PURCHASE_FROM_WERKSWAGEN: {
		defaultMessage: "Purchase from werkswagen",
		id: "vehicle.vehicleOrigin.purchaseFromWerkswagen",
	},
	TRADE_IN_FOR_NEW_CAR: {
		defaultMessage: "Trade in for new car",
		id: "vehicle.vehicleOrigin.tradeInForNewCar",
	},
	TRADE_IN_FOR_USED_CAR: {
		defaultMessage: "Trade in for used car",
		id: "vehicle.vehicleOrigin.tradeInForUsedCar",
	},
})
